import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { ManagerChartComponent } from "./manager-chart.component";
import { ChartTabComponent } from "./chart-tab.component";

@NgModule({
  declarations: [ManagerChartComponent, ChartTabComponent],
  exports: [ManagerChartComponent, ChartTabComponent],
  imports: [CommonModule, IonicModule],
})
export class ManagerChartModule {}
